import { SWITCH_MENU_VISIALITZAR_OBSERVACIONS } from "../../actions/actionTypes";

const ESTAT_INICIAL = true;

const visibilitatMenu = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case SWITCH_MENU_VISIALITZAR_OBSERVACIONS:
      return !state;
    default:
      return state;
  }
};

export default visibilitatMenu;
export const getvisibilitatMenu = state => state.visibilitatMenu;
